import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    // {
    //   // 收费支付方式审核   ----- 删除----
    //   path: '/paymentMethodAudit',
    //   name: 'PaymentMethodAudit',
    //   meta: {
    //     menu: '/paymentMethodAudit',
    //     keep: true
    //   },
    //   component: resolve => require(['@/pages/chargeMethod'], resolve)
    // },
    // {
    //   // 收费支付方式审核详情   ----- 删除----
    //   path: '/paymentMethodAuditDetails/:businessId',
    //   name: 'PaymentMethodAuditDetails',
    //   meta: {
    //     menu: '/paymentMethodAudit'
    //   },
    //   component: resolve => require(['@/pages/chargeMethod/detail'], resolve)
    // },
    {
      // 收费金额确认
      path: '/chargeConfirm',
      name: 'chargeConfirm',
      meta: {
        menu: '/chargeConfirm',
        keep: true
      },
      component: resolve => require(['@/pages/chargeConfirm'], resolve)
    },
    {
      // 收费金额确认详情
      path: '/chargeConfirmDetails/:businessId',
      name: 'chargeConfirmDetails',
      meta: {
        menu: '/chargeConfirm'
      },
      component: resolve => require(['@/pages/chargeConfirm/detail'], resolve)
    },
    {
      // 收费收据打印
      path: '/receiptPrinting',
      name: 'ReceiptPrinting',
      meta: {
        menu: '/receiptPrinting',
        keep: true
      },
      component: resolve => require(['@/pages/receiptPrint'], resolve)
    },
    {
      // 收费收据打印-PDF页
      path: '/receiptPrintPdf/:paymentId',
      name: 'ReceiptPrintPdf',
      meta: {
        menu: '/receiptPrinting'
      },
      component: resolve => require(['@/pages/receiptPrint/detail'], resolve)
    },
    {
      // 收费收据打印管理
      path: '/receiptPrintingManage',
      name: 'receiptPrintingManage',
      meta: {
        menu: '/receiptPrintingManage',
        keep: true
      },
      component: resolve => require(['@/pages/receiptPrintingManage'], resolve)
    },
    {
      // 收费收据打印管理-打印查询
      path: '/receiptPrintingSearch',
      name: 'receiptPrintingSearch',
      meta: {
        menu: '/receiptPrintingManage',
        keep: true
      },
      component: resolve => require(['@/pages/receiptPrintingManage/search'], resolve)
    },
    {
      // 收费收据打印管理-PDF页
      path: '/receiptPrintManagePdf/:paymentId',
      name: 'receiptPrintManagePdf',
      meta: {
        menu: '/receiptPrintingManage'
      },
      component: resolve => require(['@/pages/receiptPrintingManage/detail'], resolve)
    },
    {
      // 收费凭证上传
      path: '/voucherUpload',
      name: 'VoucherUpload',
      meta: {
        menu: '/voucherUpload',
        keep: true
      },
      component: resolve => require(['@/pages/voucherUpload'], resolve)
    },
    {
      // 收费凭证上传-详情
      path: '/voucherUploadDetails/:businessId',
      name: 'VoucherUploadDetails',
      meta: {
        menu: '/voucherUpload'
      },
      component: resolve => require(['@/pages/voucherUpload/detail'], resolve)
    },
    {
      // 收费审核
      path: '/chargeAudit',
      name: 'ChargeAudit',
      meta: {
        menu: '/chargeAudit',
        keep: true
      },
      component: resolve => require(['@/pages/chargeAudit'], resolve)
    },
    {
      // 收费审核详情
      path: '/chargeAuditDetails/:businessId',
      name: 'ChargeAuditDetails',
      meta: {
        menu: '/chargeAudit'
      },
      component: resolve => require(['@/pages/chargeAudit/detail'], resolve)
    },
    // 付费金额确认
    {
      path: '/payComfirm',
      name: 'PayComfirm',
      meta: {
        menu: '/payComfirm',
        keep: true
      },
      component: resolve => require(['@/pages/payComfirm'], resolve)
    },
    // 付费金额确认详情
    {
      path: '/payComfirmDetails/:receiptId',
      name: 'PayComfirmDetails',
      meta: {
        menu: '/payComfirm'
      },
      component: resolve => require(['@/pages/payComfirm/detail'], resolve)
    },
    {
    // 付费-信用票据打印
      path: '/printCreditNote',
      name: 'printCreditNote',
      meta: {
        menu: '/printCreditNote',
        keep: true
      },
      component: resolve => require(['@/pages/printCreditNote'], resolve)
    },
    {
    // 付费-信用票据打印-打印详情
      path: '/printCreditNoteDetails',
      name: 'printCreditNoteDetails',
      meta: {
        menu: '/printCreditNote'
      },
      component: resolve => require(['@/pages/printCreditNote/detail'], resolve)
    },
    {
      // 付费-信用票据打印管理
      path: '/printCreditNoteManagement',
      name: 'printCreditNoteManagement',
      meta: {
        menu: '/printCreditNoteManagement',
        keep: true
      },
      component: resolve => require(['@/pages/printCreditNoteManagement'], resolve)
    },
    {
      // 付费-信用票据打印管理-PDF页
      path: '/printCreditNoteManagementDetails',
      name: 'printCreditNoteManagementDetails',
      meta: {
        menu: '/printCreditNoteManagement'
      },
      component: resolve => require(['@/pages/printCreditNoteManagement/detail'], resolve)
    },
    {
      // 付费收据打印
      path: '/payReceiptPrinting',
      name: 'PayReceiptPrinting',
      meta: {
        menu: '/payReceiptPrinting',
        keep: true
      },
      component: resolve => require(['@/pages/payReceiptPrint'], resolve)
    },
    {
      // 付费收据打印-PDF页
      path: '/payReceiptPrintPdf/:receiptId',
      name: 'PayReceiptPrintPdf',
      meta: {
        menu: '/payReceiptPrinting'
      },
      component: resolve => require(['@/pages/payReceiptPrint/detail'], resolve)
    },
    {
      // 付费收据打印管理
      path: '/payReceiptPrintingManage',
      name: 'payReceiptPrintingManage',
      meta: {
        menu: '/payReceiptPrintingManage',
        keep: true
      },
      component: resolve => require(['@/pages/payReceiptPrintingManage'], resolve)
    },
    {
      // 付费收据打印管理-打印查询
      path: '/payReceiptPrintingManageSearch',
      name: 'payReceiptPrintingManageSearch',
      meta: {
        menu: '/payReceiptPrintingManage',
        keep: true
      },
      component: resolve => require(['@/pages/payReceiptPrintingManage/search'], resolve)
    },
    {
      // 付费收据打印管理-PDF页
      path: '/payReceiptPrintManagePdf/:receiptId',
      name: 'payReceiptPrintManagePdf',
      meta: {
        menu: '/payReceiptPrintingManage'
      },
      component: resolve => require(['@/pages/payReceiptPrintingManage/detail'], resolve)
    },
    {
      // 付费凭证上传
      path: '/payVoucherUpload',
      name: 'PayVoucherUpload',
      meta: {
        menu: '/payVoucherUpload',
        keep: true
      },
      component: resolve => require(['@/pages/payVoucherUpload'], resolve)
    },
    {
      // 付费凭证上传-详情
      path: '/payVoucherUploadDetails/:receiptId',
      name: 'PayVoucherUploadDetails',
      meta: {
        menu: '/payVoucherUpload'
      },
      component: resolve => require(['@/pages/payVoucherUpload/detail'], resolve)
    },
    {
      // 代收制盘
      path: '/agencyReceiveTray',
      name: 'AgencyReceiveTray',
      meta: {
        menu: '/agencyReceiveTray',
        keep: true
      },
      component: resolve => require(['@/pages/agencyReceiveTray'], resolve)
    },
    {
      // 代付回盘
      path: '/agencyReceiveCounteroffer',
      name: 'AgencyReceiveCounteroffer',
      meta: {
        menu: '/agencyReceiveCounteroffer',
        keep: true
      },
      component: resolve => require(['@/pages/agencyReceiveCounteroffer'], resolve)
    },
    {
      // 代付回盘明细
      path: '/agencyReceiveCounterofferDetail',
      name: 'AgencyReceiveCounterofferDetail',
      meta: {
        menu: '/agencyReceiveCounteroffer'
      },
      component: resolve => require(['@/pages/agencyReceiveCounteroffer/detail'], resolve)
    },
    {
      // 代收制盘
      path: '/agencyPayTray',
      name: 'AgencyPayTray',
      meta: {
        menu: '/agencyPayTray',
        keep: true
      },
      component: resolve => require(['@/pages/agencyPayTray'], resolve)
    },
    {
      // 代收回盘
      path: '/agencyPayCounteroffer',
      name: 'AgencyPayCounteroffer',
      meta: {
        menu: '/agencyPayCounteroffer',
        keep: true
      },
      component: resolve => require(['@/pages/agencyPayCounteroffer'], resolve)
    },
    {
      // 代收回盘明细
      path: '/agencyPayCounterofferDetail',
      name: 'AgencyPayCounterofferDetail',
      meta: {
        menu: '/agencyPayCounteroffer'
      },
      component: resolve => require(['@/pages/agencyPayCounteroffer/detail'], resolve)
    },
    {
      // 收付费查询
      path: '/paymentInquiry',
      name: 'PaymentInquiry',
      meta: {
        menu: '/paymentInquiry',
        keep: true
      },
      component: resolve => require(['@/pages/paymentInquiry'], resolve)
    },
    {
      // 收付费查询详情
      path: '/paymentInquiryDetails/:businessId',
      name: 'PaymentInquiryDetails',
      meta: {
        menu: '/paymentInquiry'
      },
      component: resolve => require(['@/pages/paymentInquiry/detail'], resolve)
    },
    {
      // 汇率定义
      path: '/exchangeRate',
      name: 'exchangeRate',
      meta: {
        menu: '/exchangeRate',
        keep: true
      },
      component: resolve => require(['@/pages/exchangeRate'], resolve)
    },
    {
    // 汇率信息
      path: '/exchangeRateDetail',
      name: 'exchangeRateDetail',
      meta: {
        menu: '/exchangeRate'
      },
      component: resolve => require(['@/pages/exchangeRate/detail'], resolve)
    },
    {
    // 增加汇率
      path: '/exchangeRateAdd',
      name: 'exchangeRateAdd',
      meta: {
        menu: '/exchangeRate'
      },
      component: resolve => require(['@/pages/exchangeRate/update'], resolve)
    },
    {
    // 修改汇率
      path: '/exchangeRateUpdate',
      name: 'exchangeRateUpdate',
      meta: {
        menu: '/exchangeRate'
      },
      component: resolve => require(['@/pages/exchangeRate/update'], resolve)
    },
    {
    // 开票-团险开票
      path: '/groupInvoice',
      name: 'groupInvoice',
      meta: {
        menu: '/groupInvoice',
        keep: true
      },
      component: resolve => require(['@/pages/groupInvoicePrint'], resolve)
    },
    {
    // 开票-团险开票-打印详情
      path: '/groupInvoicePrintDetails',
      name: 'groupInvoicePrintDetails',
      meta: {
        menu: '/groupInvoice'
      },
      component: resolve => require(['@/pages/groupInvoicePrint/detail'], resolve)
    },
    {
      // 团险开票打印管理
      path: '/groupInvoiceManage',
      name: 'groupInvoiceManage',
      meta: {
        menu: '/groupInvoiceManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupInvoiceManage'], resolve)
    },
    {
      // 团险开票打印管理-打印查询
      path: '/groupInvoiceManageSearch',
      name: 'groupInvoiceManageSearch',
      meta: {
        menu: '/groupInvoiceManage',
        keep: true
      },
      component: resolve => require(['@/pages/groupInvoiceManage/search'], resolve)
    },
    {
      // 团险开票打印管理-PDF页
      path: '/groupInvoiceManagePrintDetails/:paymentInvoiceId',
      name: 'groupInvoiceManagePrintDetails',
      meta: {
        menu: '/groupInvoiceManage'
      },
      component: resolve => require(['@/pages/groupInvoiceManage/detail'], resolve)
    },
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js